import "react-toastify/dist/ReactToastify.css";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, ButtonGroup, LinearProgress, Tooltip ,FormControl, InputAdornment, OutlinedInput} from "@mui/material";
import MUIDataTable ,{TableFilterList} from "mui-datatables";
import { useEffect, useState } from "react";
import Chip from '@mui/material/Chip';
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

import { baseUrlForEnterprise } from "../../variables/variables";

import { SearchOutlined } from "@mui/icons-material";
import axios from "axios";
import Loader from "../../components/Loader";

export default function EnterpriseList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const settings = {
      method: "GET",
      headers: {
        // Authorization: "Bearer " + Suser.token + "",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
     axios.get(baseUrlForEnterprise,settings)
     .then((res)=>{
        if(res.data.status !== "success"){
          setLoading(false)
          toast.error("Something went wrong !");
          setData([])
          return
        }
        let mydata = []
        for (let i = 0; i < res?.data.data.length; i++) {
          let newArray = res.data.data[i].attributes.map((attribute) => ({
            name: res.data.data[i].name,
            id: attribute.id,
            natureOfDispute: attribute.natureOfDispute,
            complexity: attribute.complexity,
            createdBy:attribute.createdBy,
            createdAt:attribute.createdAt
          }));
          mydata.push(newArray)
        }
        setData(mydata.flat())
        setLoading(false)
     })
     .catch((err)=>{
      setLoading(false)
      toast.error(err.message);
      setData([])
      return
     })


  }, []);


  const handleEdit = (id) => {
    navigate("/app/enterprises/crud", {
      state: data.filter(function (hero) {
        console.log(hero)
        return hero.id === id;
      }),
    });
  };

  const handleView = (id) => {
    const selectedArbitrator = data.find((item) => item.id === id);
    if (selectedArbitrator) {
      navigate("/app/enterprises/view", {
        state: { navigationData: selectedArbitrator },
      });
    } else {
      console.error("Arbitrator not found for the given ID:", id);
    }
  };

  const columns = [
    { name: "name", label: "Name", width: 100,options:{    customHeadRender: (columnMeta) => {
      return (
        <th key={columnMeta.index} style={{padding:"16px",textAlign:"left",color:"rgba(0, 0, 0, 0.6)"}}>
          {columnMeta.label}
        </th>
      );
    },} 
  },
    {
      name: "natureOfDispute",
      label: "Nature Of Dispute",
      width: 100,
      options:{
        customHeadRender: (columnMeta) => {
          return (
            <th key={columnMeta.index} style={{padding:"16px",textAlign:"left",color:"rgba(0, 0, 0, 0.6)"}}>
              {columnMeta.label}
            </th>
          );
        },
      }
    },
    {
      name: "complexity",
      label: "Complexity",
      width: 100,
      textAlign: "center",
      options: { align: "center" ,
      customHeadRender: (columnMeta) => {
        return (
          <th key={columnMeta.index} style={{padding:"16px",textAlign:"left",color:"rgba(0, 0, 0, 0.6)"}}>
            {columnMeta.label}
          </th>
        );
      },
    
    },
    },
    {
      name: "id",
      label: "Action",
      width: 150,
      options: {
        filter: true,
        customHeadRender: (columnMeta) => {
          return (
            <th key={columnMeta.index} style={{color:"rgba(0, 0, 0, 0.6)"}}>
              {columnMeta.label}
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div style={{ textAlign: "center" }}>
              <ButtonGroup style={{ alignContent: "center" }}>
                <Tooltip title="Edit">
                  <Button
                    style={{
                      color: "rgb(0, 81, 134)",
                      border: "none",
                      cursor: "pointer",
                      width:"20px"
                    }}
                  >
                    <EditIcon onClick={() => handleEdit(value)} sx={{width:"20px"}} />
                  </Button>{" "}
                </Tooltip>
                <Tooltip title="View">
                  {" "}
                  <Button
                    style={{
                      color: "rgb(0, 81, 134)",
                      border: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => handleView(value)}
                  >
                    <VisibilityIcon  sx={{width:"20px"}} />
                  </Button>
                </Tooltip>
              </ButtonGroup>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    customBodyRender: (value, tableMeta, updateValue) => {
      return (
        <span
          style={{
            display: "block",
            textAlign: tableMeta.columnData[tableMeta.colIndex].align || "center",
          }}
        >
          {value}
        </span>
      );
    },
  };
  const CustomChip = ({ label, onDelete }) => {
    return (
        <Chip
            variant="outlined"
            color="secondary"
            label={label}
            onDelete={onDelete}
        />
    );
};
  const CustomFilterList = (props) => {
    return <TableFilterList {...props} ItemComponent={CustomChip} />;
};


  return (
    <>
      <div className="navView">
        <ToastContainer />
        <Loader loading={loading} />
        <div
          className="component-titleContainer"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 className="component-title">Enterprises</h2>
          
       
        </div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <FormControl style={{ width: "600px" }}>
          <OutlinedInput
            style={{
              borderRadius: "30px",
              border: "unset",
              background: "#f8f9fb",
            }}
            size="small"
            id="header-search"
            startAdornment={
              <InputAdornment position="start">
                <SearchOutlined />
              </InputAdornment>
            }
            aria-describedby="header-search-text"
            placeholder="Search by Assignment ID, Batch ID or Enterprise Name"
            inputProps={{
              "aria-label": "weight",
            }}
          />
        </FormControl>
             <Link style={{ textDecoration: "none" }} to="/app/enterprises/create">
            <Button
              color="secondary"
              // fullWidth
              style={{
                background:
                  "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
              }}
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Create +
            </Button>
          </Link>
        </div>
       
        {loading ? (
          <LinearProgress />
        ) : ( 
          <MUIDataTable data={data} columns={columns} options={options} components={{
            TableFilterList: CustomFilterList,
          }} />
        )}
      </div>
    </>
  );
}
